import inPercy from '@percy-io/in-percy';

export const storybookStatic = !!process.env.STORYBOOK_STATIC;
export const isStorybookVisualRegression =
  (!!process.env.STORYBOOK_VISUAL_REGRESSION &&
    process.env.STORYBOOK_VISUAL_REGRESSION !== 'false') ||
  inPercy();
export const isStorybook =
  !!process.env.STORYBOOK_ENV && process.env.STORYBOOK_ENV !== 'false';
